import "react-native-gesture-handler";

import axios from "axios";
import { registerRootComponent } from "expo";
import { Platform, I18nManager } from "react-native";
import Orientation from "react-native-orientation";
import { storage } from "stores";

import App from "routers";
import { Routes } from "clients/apis/_routes";

I18nManager.allowRTL(false);
I18nManager.forceRTL(false);
Platform.OS !== "web" && Orientation.lockToPortrait();

// !for test
// axios.defaults.baseURL = "https://bazarekashan.com/api/";
// axios.defaults.baseURL = "http://192.168.1.209:8000";

//
axios.defaults.baseURL = Routes.BASE_URL;
axios.defaults.headers.get["Content-Type"] = "application/json";
axios.defaults.headers.post["Content-Type"] = "application/json";

// import * as serviceWorkerRegistration from "./src/serviceWorkerRegistration";

storage
  .get()
  .then((user) =>
    user?.token
      ? (axios.defaults.headers.common.Authorization = "Bearer " + user?.token)
      : null
  );

// !-------------------- should be remove in production -------------
// axios.interceptors.request.use(
//   (config) => {
//     console.log("public REQ CONFIG:::", config);
//     return config;
//   },
//   (error) => {
//     console.log("public REQ ERROR:::", error);
//     return Promise.reject(error);
//   }
// );

// axios.interceptors.response.use(
//   (res) => {
//     console.log("public RES RES:::", res);
//     return res;
//   },
//   (err) => {
//     console.log("public RES ERROR:::", err);
//     return Promise.reject(err);
//   }
// );
// !-------------------- ^^^^ should be remove in production ---------

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);

// serviceWorkerRegistration.register();
